export type { ErrorBody, ErrorEnvelope } from "@intility/id-errors";
export {
  FgaErrorCodes,
  IntilityIdException,
  KcErrorCodes,
  parseEnvelope,
  SpiffeErrorCodes,
} from "@intility/id-errors";

import { IntilityIdException, parseEnvelope } from "@intility/id-errors";

export async function throwIfNotOk(
  res: Response,
  plane: string = "fga",
): Promise<Response> {
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    const envelope = parseEnvelope(text, res.status, plane);
    throw new IntilityIdException(
      envelope.error.code,
      envelope.error.message,
      envelope.error.traceId,
      envelope.error.details,
    );
  }
  return res;
}
